// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import './src/jquery_import'
import './src/keystroke'
import './src/api'
import './src/toastify'
import './src/url'
import './src/asset_utils'
import {} from 'jquery-ujs'
// import 'jquery-ui/ui/widgets/datepicker';
import 'flatpickr/dist/flatpickr.min';
import * as bootstrap from "bootstrap"
import Sortable from "sortablejs/Sortable.min";
import '@nathanvda/cocoon'
import 'select2/dist/js/select2.full.js'
import Select2 from 'select2'
import './services/offcanvas_service'
import './services/reload_thumbnails_service'
import DataTable from "datatables.net-dt";
import "datatables.net-responsive";
import './feature_flags';
import './feature_flags_modal';
import 'chartkick/chart.js'
import './fetch';

Select2();

document.addEventListener('DOMContentLoaded', function () {
    const customizer_values = {}
})

document.addEventListener('turbo:load', function() {
    const leadDateSelect = document.querySelector('select[name="order_date"]');
    const startDateInput = document.querySelector('input[name="start_date"]');
    const endDateInput = document.querySelector('input[name="end_date"]');

    if (leadDateSelect && startDateInput && endDateInput) {
      leadDateSelect.addEventListener("change", function() {
        if (this.value === "") { 
          startDateInput.value = "";
          endDateInput.value = "";
        }
      });

      function resetLeadDate() {
        leadDateSelect.value = "";
      }

      startDateInput.addEventListener("change", resetLeadDate);
      endDateInput.addEventListener("change", resetLeadDate);
    }
  });


document.addEventListener("turbo:render", () => {
  attachEventListeners();
});

function attachEventListeners() {
  document.querySelectorAll(".share-btn").forEach((button) => {
    button.removeEventListener("click", handleShareClick); // Prevent duplicate bindings
    button.addEventListener("click", handleShareClick);
  });

  document.querySelectorAll(".copy-icon").forEach(copyButton => {
    copyButton.removeEventListener("click", handleCopyClick); // Prevent duplicate bindings
    copyButton.addEventListener("click", handleCopyClick);
  });

  document.querySelectorAll(".clickable-row").forEach(row => {
    row.removeEventListener("dblclick", handleRowDoubleClick); // Prevent duplicate bindings
    row.addEventListener("dblclick", handleRowDoubleClick);
  });
}

function handleShareClick(event) {
  let recordId = event.currentTarget.dataset.recordId;
  const teamName = event.currentTarget.dataset.teamName || "UNNAMED";
  const designName = event.currentTarget.dataset.designName || "UNNAMED";

  document.getElementById("modal-team-name").textContent = teamName;
  document.getElementById("modal-design-name").textContent = designName;

  let newUrl = `${window.location.protocol}//${window.location.host}/home/orders/${recordId}/copy_design_b2c`;
  document.getElementById("board-share-link").setAttribute("href", newUrl);
}

function handleCopyClick(event) {
  let linkElement =  $('#board-share-link').attr('href') 
  if (linkElement) {
    navigator.clipboard.writeText(linkElement)
      .then(() => {
        Toastify.show({ message: "Link copied to clipboard." });
      })
      .catch(err => console.error("Failed to copy:", err));
  } else {
    console.error("No valid link found.");
  }
}

function handleRowDoubleClick() {
  const url = this.getAttribute("data-url");
  if (url) {
    window.location.href = url;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  attachEventListeners();
});


$(document).ready(function () {
    const revisionText = $('td:nth-child(2)').text().trim();
    function validateInput() {
        const isRadioSelected = $('#use_revision_import_revision').is(':checked');
        const inputValue = $('#import_revision_input').val()?.trim();
        if (isRadioSelected && inputValue == '') {
            $('#order_type_next').prop('disabled', true);
        }
    }

    $('#use_revision_import_revision').on('change', function () {
        const isChecked = $(this).is(':checked');
        $('#import_revision_input').prop('disabled', !isChecked);

        validateInput();
    });

    $('#import_revision_input').on('input', function () {
        validateInput();
    });

    validateInput();
});


$(document).on('turbo:load turbo:frame-load', function () {
  const pinInput = document.getElementById("designPin");
  const searchButton = document.getElementsByClassName("importorder-link-class")[0];

  function validatePin() {
    const pinValue = pinInput.value.trim();
    const isValid = /^[a-zA-Z0-9]+$/.test(pinValue);

    if (isValid && pinValue.length > 0) {
      searchButton.classList.remove("disabled");
    } else {
      searchButton.classList.add("disabled");
    }
  }

  pinInput?.addEventListener("input", validatePin);

  pinInput?.addEventListener("keypress", function (event) {
    const char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z0-9]$/.test(char)) {
      event.preventDefault();
    }
  });
});



$(document).on('turbo:load', function () {
    function toggleImportRevisionInput() {
        const importRevisionRadio = $('#use_revision_import_revision');
        const importRevisionInput = $('#import_revision_input');
        const revisionTable = $('.clickable-table');
        const $tableRows = $('.clickable-row');
        const isRadioSelected = $('#use_revision_import_revision').is(':checked');
        const inputValue = $('#import_revision_input').val()?.trim();

        if (isRadioSelected && inputValue == '') {
            $('#order_type_next').prop('disabled', true);
        }

        if (importRevisionRadio.is(':checked')) {
            importRevisionInput.prop('disabled', false);
            revisionTable.hide();
        } else {
            importRevisionInput.prop('disabled', true);
            revisionTable.show();
        }
    }

    toggleImportRevisionInput();

    $('input[name="use_revision"]').on('change', function () {
        toggleImportRevisionInput();
    });
});

$(document).on("turbo:load", function() {
    const $importRevisionInput = $('#import_revision_input');
    const $errorContainer = $('#import_revision_error');
    const $tableRows = $('.clickable-row');
    const revisionTable = $('.clickable-table');
    const $withoutRevision = $('#use_revision_without_revision');
    const $withRevision = $('#use_revision_with_revision');

    function toggleTableRows() {
        if ($withoutRevision.is(':checked') || $withRevision.is(':checked')) {
            $tableRows.show();
            $importRevisionInput.prop('disabled', true);
            $('#order_type_next').prop('disabled', false);
            $importRevisionInput.val('');
            $errorContainer.text('').show()
        } else {
            $tableRows.hide();
        }
    }

    $withoutRevision.on('change', toggleTableRows);
    $withRevision.on('change', toggleTableRows);

  if ($importRevisionInput.length) {
    $importRevisionInput.on('blur', function() {
      const value = $importRevisionInput.val().trim();
      const pattern = /^\d+-\d+[A-Z]-\d+$/;

      if (value && !pattern.test(value)) {
      $errorContainer.text("INVALID REVISION SELECTED FOR THIS PRODUCT").show();
      $('#order_type_next').prop('disabled', true);

      return;

      } else {
        $errorContainer.text("").hide();
      }

      let foundMatch = false;

      $tableRows.each(function() {
        const revisionText = $(this).find('td:nth-child(1)').text().trim();

        if (revisionText === value) {
          foundMatch = true;
          revisionTable.show()
          $('#order_type_next').prop('disabled', false);
          makeActive($(this))
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      if (!foundMatch) {
        $errorContainer.text("No matching revision found").show();
        $('#order_type_next').prop('disabled', true);
      }
    });
  }
});

$(document).on('turbo:load', function () {
    $("#flash-msg").delay(5000).fadeOut(500);
    $('#flash_link').on('click', function () {
        $('#flash-msg').hide();
    })
})

$(document).on('turbo:load', function() {
    flatpickr('.date-picker-formated', {
        dateFormat: 'Y-m-d'
    });
});

$(document).on('turbo:load cocoon:after-remove cocoon:after-insert cocoon:after-append', function () {
    $('select.select2').select2()
})

$(document).on('turbo:before-cache', function () {
    $('select.select2').select2('destroy');
});

$(document).on('turbo:before-fetch-request', function (event) {
    if (event.target.dataset["turboStream"] == "false") {
        event.detail.fetchOptions.headers["Accept"] = "text/html, application/xhtml+xml";
    }
});


$(document).on('turbo:load turbo:frame-load', function () {
    activateRow()
    newOrderPage()

    manageSortableFields();
    handleOrderDateChange()
    setPageSize()

    $('select.select2').select2()

    $('#pageSize').val($('#selectedPageSize').val())

    $('#aetrex_next_button').on('click', function () {
        visitPlayer()
    })

    $('#aetrex_assign_customize_button').on('click', function () {
        assignPlayer(true)
    })

    $('#aetrex_customize_button').on('click', function () {
        aetrexToNewPlayer()
    })

    $('#add_to_cart').on('click', function () {
        customizer.addToCart();
    })
    //
    // function handleAddToCartEvent(event) {
    //     const path = $('#add_to_cart').attr('data-path');
    //     console.log("Navigating to " + path);
    //     setTimeout(() => {
    //         window.location.href = path;
    //     }, 2000);
    // }
    //
    // document.addEventListener('customizer.add-to-cart.success', handleAddToCartEvent);

    $('#reset-button').on('click', function() {
        // Reset the select2 field
        $('#reset-button').parents('form').find('.select2-hidden-accessible').val(null).trigger('change');
    });

    $('#submit_terms_checkbox').on('change', function () {
        toggleSubmitButton()
    })
    toggleSubmitButton()

    overrideAddress()
    updateShipToSelectStatus();

    $('#ship_to_override').on('change', function () {
        overrideAddress()
    })

    $('#ship_to_select').on('change', function () {
        let override_checkbox = $('#ship_to_override')

        if ($('#ship_to_select option:selected').text().includes('MUST OVERRIDE') || (($('#has_override').val() === 'true') && $('#current_ship_to_account').val() === $(this).val() )) {
            override_checkbox.prop('checked', true)
            override_checkbox.prop('disabled', true)
            $('#must_override').val('1')
        } else {
            $('#must_override').val(null)
            override_checkbox.prop('checked', false)
            if ($('#disable_ship_to_override').val() !== '1') {
                override_checkbox.prop('disabled', false)
            }
        }

        overrideAddress()
        updateShipToSelectStatus()
    })

    generateSoldToSelect();

    $('#customer_select').on('change', function () {
        generateSoldToSelect();
    })

    $('#sold_to_select').on('change', function () {
        generateShipToSelect();
        updateShipToSelectStatus();
    })

    // adjustLeagueSelect();
    $('.league_select').on('change', function () {
        // adjustLeagueSelect();
    })

    $('.password-toggle').on('click', function () {
        let inputGroup = $(this).closest('.input-group');
        let passwordInput = inputGroup.find('input');

        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            $(this).removeClass('bi-eye-slash').addClass('bi-eye');
        } else {
            passwordInput.attr('type', 'password');
            $(this).removeClass('bi-eye').addClass('bi-eye-slash');
        }
    })

    $('#delete_btn').on('click', function () {
        const order_id = $('.active-row').data('id')
        $('.delete-lead-class').attr('href', `leads/${order_id}`);
    })

    $('#order_index_recall').on('click', function () {
        const order_id = $('.active-row').data('id')
        $('.submit-link-class').attr('href', `orders/${order_id}/update_status`);
    })

    $('#order_index_delete').on('click', function () {
        const order_id = $('.active-row').data('id')
        $('.delete-link-class').attr('href', `orders/${order_id}`);
    })

    $('#convert_btn').on('click', function () {
        const order_id = $('.active-row').data('id')
        $('.convert-link-class').attr('href', `leads/${order_id}/convert`);
    })

    $('#order_index_copy').on('click', function () {
        const order_id = $('.active-row').data('id')
        $('.copyorder-link-class').attr('href', `/orders/${order_id}/copy`);
    })



   $(document).ready(function () {
     $('.importorder-link-class').on('click', function () {
       const pin = document.getElementById("designPin").value;
       $.ajax({
         url: `/orders/${pin}/import_order`,
         type: "GET",
         dataType: "json",
         success: function (response) {
           if (response.order) {
             $('#pinError').hide();
             $('#orderDetails').html(`
               <p class="no-transform"><strong>PIN:</strong> ${response.order.pin}</p>
               <p><strong>CREATED BY:</strong> ${response.order.created_by}</p>
               <p><strong>CREATED AT:</strong> ${response.order.created_at}</p>
               <p><strong>TEAM:</strong> ${response.order.team || ''}</p>
               <p><strong>DESIGN:</strong> ${response.order.design || ''}</p>
               <p><strong>PRODUCTS:</strong></p>
               <ul>
                 ${response.order.products.map(product => `<li>${product}</li>`).join('')}
               </ul>
               <div class="p-4 justify-content-start">     
                <span  data-bs-dismiss="modal">
                   <button type="button" id="confirmImport" class="btn btn-primary loadorder-link-class" data-order-id="${response.order.order_id}">Load</button>
                 </span>
               </div>
             `).show();
           } else {
             $('#orderDetails').hide();
             $('#pinError').show();
           }
         },
         error: function () {
           $('#orderDetails').hide();
           $('#pinError').show();
         }
       });
     });
   
     $(document).on('input', '#orderNumber', function () {
       const val = $(this).val().trim();
       if (val.length > 0) {
         $('.importorder-link-class').removeClass('disabled').prop('disabled', false);
       } else {
         $('.importorder-link-class').addClass('disabled').prop('disabled', true);
       }
     });

     $(document).on("click", ".loadorder-link-class", function () {
       const orderId = $(this).data("order-id");
       const teamId =  $('.active-row').data('teamGridIdParam')
       const form = document.createElement("form");
       form.method = "POST";
       form.action = `/orders/${orderId}/copy?team_id=${teamId}`;
       const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
       const csrfInput = document.createElement("input");
       csrfInput.type = "hidden";
       csrfInput.name = "authenticity_token";
       csrfInput.value = csrfToken;
       form.appendChild(csrfInput);
       document.body.appendChild(form);
       form.submit();
     });
   });
    
    $(document).on('click', '.importorder-class', function (e) {
       e.preventDefault();
       if ($(this).hasClass('disabled')) return;
       const onumber = $('#orderNumberImport').val().trim();
       $.ajax({
         url: `/orders/${onumber}/import_order_number`,
         type: 'GET',
         dataType: 'json',
         success: function (response) {
           if (response.order) {
             $('#pinError').hide();
             $('#orderDetails').html(`
               <p class="no-transform"><strong>ORDER NUMBER:</strong> ${response.order.order_number}</p>
               <p><strong>CREATED BY:</strong> ${response.order.created_by}</p>
               <p><strong>CREATED AT:</strong> ${response.order.created_at}</p>
               <p><strong>PRODUCTS:</strong></p>
               <ul>
                 ${response.order.products.map(product => `<li>${product}</li>`).join('')}
               </ul>
               <div class="p-4 justify-content-start">     
                 <span data-bs-dismiss="modal">
                   <button type="button" class="btn btn-primary loadorder-class" data-order-id="${response.order.order_id}">Load</button>
                 </span>
               </div>
             `).show();
           } else {
             $('#orderDetails').hide();
             $('#pinError').show();
           }
         },
         error: function () {
           $('#orderDetails').hide();
           $('#pinError').show();
         }
       });
     });

     $(document).on('input', '#orderNumberImport', function () {
       const val = $(this).val().trim();
       if (val.length > 0) {
         $('.importorder-class').removeClass('disabled').prop('disabled', false);
       } else {
         $('.importorder-class').addClass('disabled').prop('disabled', true);
       }
     });

     $(document).on('click', '.loadorder-class', function () {
       const orderId = $(this).data("order-id");
       const teamId = $('.active-row').data('teamGridIdParam');
       const form = document.createElement("form");
       form.method = "POST";
       form.action = `/orders/${orderId}/copy_order?team_id=${teamId}`;
       const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
       const csrfInput = document.createElement("input");
       csrfInput.type = "hidden";
       csrfInput.name = "authenticity_token";
       csrfInput.value = csrfToken;
       form.appendChild(csrfInput);
       document.body.appendChild(form);
       form.submit();
     });



    $('#order_index_hold_under_review').on('click', function () {
        const order_line_id = $('.active-row').data('line')
        $('.hold-under-review-link-class').attr('href', `orders/${order_line_id}/hold_or_under_review`);
    })

    $('#order_index_edit').on('click', function () {
        redirectToEdit()
    })

    $('#edit_btn').on('click', function () {
        redirectToEditLead()
    })



    $('#order_index_show').on('click', function () {
        redirectToShow()
    })

    $(document).on('click', '#order_index_history', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(e.target).closest('#order_index_history');
        var orderId = ($btn.length && $btn.data('order-id')) || $('.active-row').data('id');
        var href = $btn.length ? $btn.attr('href') : '';
        if (orderId) {
            window.location.href = '/audit_trail/orders/' + orderId;
        } else if (href && href.indexOf('/audit_trail/orders/') === 0) {
            window.location.href = href;
        }
    });

    $('#lead_index_show').on('click', function () {
        redirectToShowLeads()
    })


    $('#order_index_rework').on('click', function () {
        redirectToCustomizer({ rework: true })
    })

    $('#order_index_oa').on('click', function () {
        redirectToCustomizer({ oa: true })
    })

    $('#leads_assign').on('click', function () {
        const lead_id = $('.active-row').data('id')
        Turbo.visit(`leads/new?type=lead&lead_id=${lead_id}`, { frame: "_top" });
    })

    $('#order_index_download_summary, #order_index_download_specs').on('click', function () {
        const link = $(this).clone();
        const active_row = $('.active-row');
        const order_id = active_row.data('id');

        link
            .attr('href', link.attr('href').replace('order_id', order_id))
            .hide()
            .appendTo(document.body);

        link.get(0).click();

        link.remove();

        return false;
    })


    crdValidation()

    $('.with-scan, .without-scan').on('change', function () {
        toggleCustomizationTypeSection();
    });
    toggleCustomizationTypeSection()

    // $('#expedite_checkbox').on('change', function () {
    //     if ($(this).is(':checked')) {
    //         $('.confirmed_xfd').removeClass('d-none')
    //     } else {
    //         if ($('#only_expedite').val() === '1') {
    //             $('.confirmed_xfd').addClass('d-none')
    //
    //         }
    //     }
    //
    // })

    generateItemCategorySelect();
    $('.scenario_select').on('change', function () {
        generateItemCategorySelect();
    })

    updateAvailableOrganizations();

    $('.confirmed_xfd_input').on('change', function () {
        if ($(this).val() !== $('#original_confirmed_xfd').val()) {
            $('.confirmed_reason_select').prop('required', true)
        } else {
            $('.confirmed_reason_select').prop('required', false)
        }
    })

    $('#business_scenario').on('change', function() {
        // updateItemCategoryState();
    });

    $('input[type="radio"][name="view_mode"]').on('change', function() {
        switchViewMode($(this).val());
    })

    // updateItemCategoryState()
});

function switchViewMode(viewMode) {
    const form = document.getElementById('ordersSearchForm');
    const spinner = document.getElementById('orderIndexSpinner');
    const viewModeInput = document.createElement('input');
    spinner?.classList.remove('d-none');
    spinner?.classList.add('d-flex');
    viewModeInput.type = 'hidden';
    viewModeInput.name = 'view_mode';
    viewModeInput.value = viewMode;
    form.appendChild(viewModeInput);
    form.requestSubmit();
}


$(document).on('change', '.user_column_checkbox', function (ev) {
    toggleColumnSelectionButtons();
})

$(document).on('change', '.selectable_column_checkbox', function (ev) {
    toggleColumnSelectionButtons();

})

$(document).on('click', '.aetrex-assign-link', function (event) {
    event.preventDefault();
    assignPlayer(false)
})

$(document).on('click', '#remove_column_selection_button', function (ev) {
    removeCheckedColumnSelections();
})

$(document).on('click', '#add_column_selection_button', function (ev) {
    addCheckedColumnSelections();
})

$(document).on('click', '#add_all_columns', function (e) {
    addAllColumns()
})

$(document).on('click', '#remove_all_columns', function () {
    removeAllColumns()
})

document.addEventListener('turbo:frame-load', () => {
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
});

$(document).on('click', '.remove-organization-icon', function (event) {
    event.preventDefault();
    $(this).closest('.nested-fields').remove();
})

// Bind to cocoon's after-insert and after-remove
$(document).on('cocoon:after-insert cocoon:after-remove', function () {
    updateAvailableOrganizations();
});

// Also bind to change event to handle selections
$(document).on('change', '.team-select', function () {
    updateAvailableOrganizations();
});

$(document).on('click', '#resetColumnsBtn', function () {
    resetColumnsToDefault()
})

function setPageSize() {
    $('#pageSize').on('change', function () {
        $('#selectedPageSize').val($('#pageSize').val())
        $('#ordersSearchForm')[0].submit();
    })
}

function toggleColumnSelectionButtons() {
    if ($('.selectable_column_checkbox:checked').length)
        $('#add_column_selection_button').prop('disabled', false)
    else
        $('#add_column_selection_button').prop('disabled', 'disabled')

    if ($('.user_column_checkbox:checked').length)
        $('#remove_column_selection_button').prop('disabled', false)
    else
        $('#remove_column_selection_button').prop('disabled', 'disabled')
}


function addCheckedColumnSelections() {
    $('.selectable_column_checkbox:checked').each(function () {
        let attribute_name = $(this).attr("name")
        let column_div = $(this).closest('.selectable_column')
        let display_name = column_div.find('.column_attr_display').html()
        $('.user_column:last').after('<div class="user_column row"><div class="handle col-auto"><i class="bi-arrows-move"></i></div>' +
            '<div class="col-auto">' +
            '<input type="checkbox" name="' + attribute_name + '" id="" value="1" class="user_column_checkbox">' +
            ' <span class="column_attr_display">' + display_name + '</span>' +
            ' <input type="hidden" name="columns[' + attribute_name + '[name]]" value="1" autoComplete="off">' +
            '   <input type="hidden" name="columns[' + attribute_name + '[position]" class="object_order" autoComplete="off">' +
            '</div>' +
            '</div>'
        )
        if (attribute_name.includes('.'))
            $('#columns_group_by_select').append($("<option></option>").attr("value", attribute_name).text(display_name));
        column_div.remove()
        $('#add_column_selection_button').prop('disabled', 'disabled')

    })
}

function addAllColumns() {
    $('.selectable_column_checkbox').prop('checked', true); // Select all checkboxes
    $('.selectable_column_checkbox:checked').each(function () {
        let attribute_name = $(this).attr("name");
        let column_div = $(this).closest('.selectable_column');
        let display_name = column_div.find('.column_attr_display').html();
        $('.user_column:last').after('<div class="user_column row"><div class="handle col-auto"><i class="bi-arrows-move"></i></div>' +
            '<div class="col-auto">' +
            '<input type="checkbox" name="' + attribute_name + '" id="" value="1" class="user_column_checkbox">' +
            ' <span class="column_attr_display">' + display_name + '</span>' +
            ' <input type="hidden" name="columns[' + attribute_name + '[name]]" value="1" autoComplete="off">' +
            '   <input type="hidden" name="columns[' + attribute_name + '[position]" class="object_order" autoComplete="off">' +
            '</div>' +
            '</div>'
        );
        if (attribute_name.includes('.'))
            $('#columns_group_by_select').append($("<option></option>").attr("value", attribute_name).text(display_name));
        column_div.remove();
        $('#add_column_selection_button').prop('disabled', 'disabled');


    });
}


function removeCheckedColumnSelections() {
    $('.user_column_checkbox:checked').each(function () {
        let checkbox = $(this);
        let column_div = checkbox.closest('.user_column');
        let display_name = column_div.find('.column_attr_display').text();
        let attribute_name = checkbox.attr("name");

        $('.selectable_column:last').after('<div class="selectable_column">' +
            '<input type="checkbox" name="' + attribute_name + '" id="" value="1" class="selectable_column_checkbox">' +
            ' <span class="column_attr_display">' + display_name + '</span>' +
            '</div>'
        )
        $(`#columns_group_by_select option[value='${attribute_name}']`).remove();
        column_div.remove()
        $('#remove_column_selection_button').prop('disabled', 'disabled')

    })
}

function removeAllColumns() {
    $('.user_column_checkbox').prop('checked', true);
    $('.user_column_checkbox:checked').each(function () {
        let attribute_name = $(this).attr("name");
        let column_div = $(this).closest('.user_column');
        let display_name = column_div.find('.column_attr_display').html();
        $('.selectable_column:last').after('<div class="selectable_column">' +
            '<input type="checkbox" name="' + attribute_name + '" id="" value="1" class="selectable_column_checkbox">' +
            ' <span class="column_attr_display">' + display_name + '</span>' +
            '</div>'
        );
        $(`#columns_group_by_select option[value='${attribute_name}']`).remove();
        column_div.remove();
        $('#remove_column_selection_button').prop('disabled', 'disabled')
    });
}

function resetColumnsToDefault() {
    const defaultColumns = ['product_category', 'player_last_name', 'player_first_name', 'player_id', 'team_name', 'league', 'order_number',
                       'order_type', 'sales_order_number', 'quantity', 'customer_po', 'order_date', 'customer_requested_date',
                       'order_status', 'order_ship_method_description', 'fulfillment_tracking_number'];

    removeAllColumns();

    defaultColumns.forEach(function(column) {
        if (!$(`.user_columns input[name='${column}']`).length) {
            $('.user_columns').append(
                `<div class="user_column row">
                    <div class="handle col-auto">
                        <i class="bi-arrows-move"></i>
                    </div>
                    <div class="col-auto">
                        <input type="checkbox" name="${column}" value="1" class="user_column_checkbox">
                        <span class="column_attr_display">${formatedColumn(column)}</span>
                        <input type="hidden" name="columns[${column}[name]]" value="1" autoComplete="off">
                        <input type="hidden" name="columns[${column}[position]]" class="object_order" autoComplete="off">
                    </div>
                </div>`
            );
        }
    });
    defaultColumns.forEach(function (column) {
        $(`.selectable_columns .selectable_column input[name='${column}']`).closest('.selectable_column').remove();
    });
}

function formatedColumn(column) {
  let words = column.split('_');

  words = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

  return words.join(' ');
}

function activateRow() {
    $('.clickable-table').each(function () {
        let current_row = $(this).find(".current_player_row")
        if (current_row.length) {
            makeActive(current_row)
        }

        $(this).find('.clickable-row').on('click', function (event) {
            makeActive($(this))
        })

        if ($(this).find('.clickable-row.active-row').length)
            $(this).find('.clickable-row.active-row').trigger('click');
        else if ($(this).data('autoselectFirst') !== false)
            $(this).find('.clickable-row:first').trigger('click');

        // if ($(this).find('.clickable-row.active-row').data('bauerData') !== undefined) {
            // getBauerData();
        // }

    });
}

function makeActive(row) {
    row.closest('.clickable-table').find('.active-row').removeClass('active-row');
    row.addClass('active-row')
    row.closest('.clickable-table').find('.clickable-row').each(function () {
        $(this).find('td').each(function () {
            $(this).css('background-color', 'white')
        })
    })

    row.find('td').each(function () {
        $(this).css('background-color', '#adb5bd')
    })

    let id = row.data('id');
    let status = row.data('status');
    let lineStatus = row.data('order-line-status');
    let salesChannel = row.data('sales_channel')?.toLowerCase();
    let segment = row.data('segment');
    let historical = row.is('[data-historical]');
    let productActive = row.is('[data-product-active]')
    let variantActive = row.is('[data-variant-active]')
    let orderHasRecipeToken =  row.is('[data-order-has-recipe-token]')
    let leadStatus =  row[0].getAttribute('data-status')
    let org = row[0].getAttribute('data-org') === "true";
    let revisionActive = row.data('active');
    let revisionId = row.data('revision-id');
    if (revisionId && !revisionActive) {
      $('#order_type_next').prop('disabled', true);
    } else if(revisionId) {
      $('#order_type_next').prop('disabled', false);
    }

    if (leadStatus == "lead" || leadStatus == "LEAD") {
      if (org) {
        $("#convert_btn").removeClass("disabled");
        $("#convert_btn").removeClass("disabled_buttons");
      } else {
        $("#convert_btn").addClass("disabled");
        $("#convert_btn").addClass("disabled_buttons");
      }
      $("#edit_btn").removeClass("disabled");
      $("#edit_btn").removeClass("disabled_buttons");
      $("#leads_assign").removeClass("disabled");
      $("#leads_assign").removeClass("disabled_buttons");
      $("#delete_btn").removeClass("disabled");
      $("#delete_btn").removeClass("disabled_buttons");
    } else {
      $("#convert_btn").addClass("disabled");
      $("#convert_btn").addClass("disabled_buttons");
      $("#edit_btn").addClass("disabled");
      $("#edit_btn").addClass("disabled_buttons");
      $("#leads_assign").addClass("disabled");
      $("#leads_assign").addClass("disabled_buttons");
      $("#delete_btn").addClass("disabled");
      $("#delete_btn").addClass("disabled_buttons");
    };
    let isSkate = row.is('[data-is-skate]')

    const roles = window.app.user.roles.map(r => r.toUpperCase().trim());

    $('.disabled_buttons').each(function () {
        $(this).addClass('disabled')

        let buttonState = [
          {
            button: "order_index_edit",
            enabledStatuses: [
              "ADMINISTRATORS",
              "CUSTOMER SERVICE",
              "PRO SHOP",
            ].some((r) => window.app.user.roles.some((ur) => ur.startsWith(r)))
              ? [
                  "design",
                  "draft",
                  "submitted",
                  "credit_hold",
                  "processing",
                  "produced",
                  "under_review",
                  "approved",
                  "new_order",
                  "on_hold",
                  "fulfilled"
                ]
              : ["design", "draft", "under_review"],
          },
          {
            button: "order_index_show",
            enabledStatuses: [
              "draft",
              "under_review",
              "submitted",
              "credit_hold",
              "processing",
              "produced",
              "fulfilled",
              "canceled",
              "new_order",
              "on_hold",
            ],
          },
          {
            button: "order_index_delete",
            enabledStatuses: ["design", "draft"],
            enabledSalesChannels: ["b2b"],
          },
          {
            button: "order_index_cancel",
            enabledStatuses: (() => {
              if (roles.some(r => ["RETAILERS", "SALES REPS"].some(b => r.startsWith(b)))) {
                const hardBlockedStatuses = [
                  "design",
                  "draft",
                  "fulfilled",
                  "submitted",
                  "credit_hold",
                  "processing",
                  "new_order",
                  "on_hold",
                  "produced",
                  "canceled",
                  "under_review"
                ];
                return (
                  (window.orderCancelPermissions &&
                    roles.flatMap(userRole => {
                      return (
                        Object.entries(window.orderCancelPermissions).find(
                          ([role, _]) => userRole.startsWith(role)
                        )?.[1] ?? []
                      );
                    })) || []
                ).filter(st => !hardBlockedStatuses.includes(st));
              }
              if (roles.some(r => r.startsWith("DISTRIBUTORS"))) {
                return (
                  (window.orderCancelPermissions &&
                    roles.flatMap(userRole => {
                      return (
                        Object.entries(window.orderCancelPermissions).find(
                          ([role, _]) => userRole.startsWith(role)
                        )?.[1] ?? []
                      );
                    })) || []
                ).filter(st => !["design", "draft", "fulfilled", "under_review"].includes(st));
              }
              let statuses =
                (window.orderCancelPermissions &&
                  roles.flatMap(userRole => {
                    return (
                      Object.entries(window.orderCancelPermissions).find(
                        ([role, _]) => userRole.startsWith(role)
                      )?.[1] ?? []
                    );
                  })) || [];

              statuses = statuses.filter(st => !["fulfilled"].includes(st));

              if (roles.some(r => ["ADMINISTRATORS", "CUSTOMER SERVICE", "PRO SHOP"].some(b => r.startsWith(b)))) {
                statuses = statuses.filter(st => !["design", "draft"].includes(st));
              }

              return statuses;
            })(),
            enabledSalesChannels: ["b2b"],
            isEnabled: (rowEl, status) => {
              const lineStatus = rowEl.dataset.orderLineStatus; 
              if (lineStatus === "canceled") {
                return false;
              }
              return true;
            }
          },
          {
            button: "order_index_copy",
            enabledStatuses: [
              ...(segment == "TEAM" ? ["design", "draft"] : []),
              ...(segment == "TEAM" || roles.includes("SALES REPS - EAS") ? ["under_review"] : []),
              "submitted",
              "credit_hold",
              "processing",
              "produced",
              "fulfilled",
              "canceled",
              "new_order",
              "on_hold",
            ],
            enabledSalesChannels: ["b2b"],
            enabledSegments: ["TEAM", "PLAYER"],
          },
          {
            button: "order_index_recall",
            enabledStatuses: ["under_review"],
            enabledSalesChannels: ["b2b"],
          },
          { button: "order_next_step", enabledStatuses: ["active"] },
          { button: "export_bulks", enabledStatuses: ["active"] },
          { button: "import_bulks", enabledStatuses: ["active"] },
          { button: "aetrex_next_button", enabledStatuses: [] },
          { button: "aetrex_assign_button", enabledStatuses: ["active"] },
          {
            button: "aetrex_assign_customize_button",
            enabledStatuses: ["active"],
          },
          { button: "offcanvas-link-edit", enabledStatuses: [] },
          {
            button: "order_index_hold_under_review",
            enabledStatuses: ["under_review", "on_hold"],
          },
          {
            button: "order_index_rework",
            enabledStatuses: ["fulfilled"],
            enabledSegments: ["PLAYER"],
            skateOnly: true,
          },
          {
            button: "order_index_oa",
            enabledStatuses: [],
            enabledLineStatuses: [
              "submitted",
              "new_order",
              "processing",
              "credit_hold",
            ],
            enabledSegments: ["development", "qa"].includes(window.app.env)
              ? null
              : ["PLAYER"],
            skateOnly: !["development", "qa"].includes(window.app.env),
          },
        ];

        buttonState.forEach(function (button) {
            const btnStatuses = button.enabledStatuses;

            if (button.enabledForHistorical === false && historical ||
                button.enabledForActiveProduct === true && !productActive ||
                button.enabledForActiveVariant === true && !variantActive
            ) {
                return;
            }

            // enable for PLAYER or TEAM
            if (button.enabledSegments && !button.enabledSegments.includes(segment)) {
                return
            }

            if (button.skateOnly && !isSkate) {
                return;
            }

            if (
              salesChannel &&
              button.salesChannels &&
              !button.salesChannels.includes(salesChannel)
            ) {
              return;
            }

            if (button.enabledLineStatuses?.length && !button.enabledLineStatuses.includes(lineStatus)) {
                return
            }

            if (
              (btnStatuses.includes(status) ||
                btnStatuses.length === 0 ||
                (salesChannel == "b2c" &&
                  ["order_index_edit", "order_index_show"].includes(button.button))) &&
              (!button.isEnabled || button.isEnabled(row[0], status)) 
            ) {
              $(`#${button.button}`).removeClass("disabled");
            }
        })

        if ($(this).attr('id') === 'aetrex_customize_button' && id) {
            $(this).removeClass('disabled')
        }

        if (row.data('player-status') && row.data('player-status') == 'active') {
            $('#aetrex_assign_button').removeClass('disabled')
            $('#aetrex_assign_customize_button').removeClass('disabled')
        }
        if(row.data('team-status') && row.data('team-status') == 'active' && row.data('player-status') != 'inactive'){
            $('#order_next_step').removeClass('disabled')
            $('#export_bulks').removeClass('disabled')
            $('#import_bulks').removeClass('disabled')

            let status =
                $("select[name=destination]").val() || $.url().qs("as") || "active";

            const $asset_logos = $('#asset_logos');

            $asset_logos.length && $asset_logos.reload(
                `/asset_groups/small_logos?as=${status}&organization_id=${row.data('team')}`,
            );
        }
        if ($(this).attr('id') === 'order_index_hold_under_review') {
            const proShop = window.app.user.roles.includes('PRO SHOP')

            if (proShop) {
                let linkText = 'ON HOLD'
                if (status === 'on_hold')
                    linkText = 'UNDER REVIEW'

                $('a#order_index_hold_under_review').text(linkText)
            } else {
                $(this).addClass('disabled')
            }
        }

    })

    $("#order_index_delete").each(function () {
      let url = `orders/${id}/delete_modal`;

      if ($("input[name=view_mode]:checked").val() == "order_line_list") {
        url += `?order_line_id=${row.data("line")}`;
      }

      $(this).attr("href", url);
    });

    $("#order_index_cancel").each(function () {
        let url = `orders/${id}/cancel_modal`;
  
        if ($("input[name=view_mode]:checked").val() == "order_line_list") {
          url += `?order_line_id=${row.data("line")}`;
        }
  
        $(this).attr("href", url);
      });

    var $frame = row.closest('turbo-frame');
    if ($frame.length) {
      $frame.attr('data-selected-order-id', id || '');
    }

    $('#order_index_download_specs').toggle(orderHasRecipeToken);

    let customizer_scan_hash_field = $('#order_types_scan_id')
    if (customizer_scan_hash_field.length && row.data('scan') !== undefined) {
        customizer_scan_hash_field.val(row.data('scan'))
        // getBauerData()
    }

    enableRecipeSummaryLink(row)
    teamsByPlayer();
    setRecipe();
}

function enableRecipeSummaryLink(row) {

    if (row.data('recipe')) {
        $('#recipeSummaryLink').removeClass('disabled')
        bindRecipeModal()
    }
}

function bindRecipeModal() {
    $('#recipeSummaryLink').off('click').on('click', function (event) {
        event.preventDefault();
        bindOffcanvasClose()
        const row = $('.active-row');

        $.ajax({
            url: `/recipe-summary?recipe_id=${row.data('recipe')}&id=${row.data('id')}&order_line_id=${row.data('line')}&source=${$(this).data('source')}`,
            method: 'GET',
            success: function(response) {
                $('#recipeModalCanvas').addClass('show')
                $('#recipeModal').html(response);
                // Bind revision status radio buttons after modal content is loaded
                bindRevisionStatusRadioButtons();
            },
            error: function(error) {
                console.log('error message', error.statusText)
                alert(error.statusText)
            }
        })
    })
}

// Function to bind revision status radio button functionality
function bindRevisionStatusRadioButtons() {
    const radioButtons = $('.revision-status-radio');    
    radioButtons.off('click').on('click', function(e) {
        const revisionId = e.currentTarget.dataset.revisionId;
        const status = e.currentTarget.dataset.status;
        const isActive = status === 'true';
        const wasActive = e.currentTarget.dataset.active === true;
        e.preventDefault();
        e.stopPropagation();
        if (e.currentTarget.checked === wasActive) {
            return;
        }
        const modalId = isActive ? 
            `revision-status-${revisionId}-active` : 
            `revision-status-${revisionId}-inactive`;
        const modal = new bootstrap.Modal(document.getElementById(modalId), {
            backdrop: false
        });
        modal.show();
    });
}

function setRecipe() {
    const activeRevision = $('.revisions').find('.active-row');

    if (activeRevision.length) {
        let recipeIdField = $('#recipeId');
        let line_recipe = $('#lineRecipeId');

        let revisionField = $('#revisionId');
        if(!line_recipe.val()) {
            recipeIdField.val(activeRevision.data('recipe-id'));
        }
        revisionField.val(activeRevision.data('revision-id'))
    }
}

// function getBauerData() {
//     const activeRow = $('.order_type_scans').find('.active-row');

//     const scanHash = activeRow.data('scan-hash');

//     $.ajax({
//         url: `/orders/size_and_fit_data`,
//         method: 'GET',
//         data: {scan_hash: scanHash},
//         success: function (response) {
//             setBauerData(response)
//         },
//         error: function (xhr, status, error) {
//             console.error(xhr.responseText);
//         }
//     });
// }

// function setBauerData(data) {
//     if ($('#bauerFitType') && $('#bauerSize')) {
//         $('#bauerFitType').val(data['bauerFitType'])
//         $('#bauerSize').val(data['bauerSize'])
//     }
// }

function newOrderPage() {
    $('.offcanvas-link-edit').on('click', function (event) {
        event.preventDefault();
        const playerId = $('.active-row').data('player');

        openPlayerModal()
        $.ajax({
            url: `/individuals/${playerId}/edit`,
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (data) {
                $('#playerModalContent').html(data);
                $('.offcanvas-add-another').addClass('d-none')
                bindOffcanvasClose()
                bindSubmitPlayer()
            }
        });
    })

    $('.offcanvas-link-add[aria_controls=playerFormCanvas]').on('click', function (event) {
        event.preventDefault();

        openPlayerModal()
        newPlayerForm()
    })

    $('#playerModalContent').on('click', '.offcanvas-add-another', function (event) {
        if (!isValidPlayer()) {
            event.preventDefault();
            bindPlyerValidation($('#playerModalContent form'))
            return
        }
        $(this).closest('form').append($('<input>').attr({
            type: 'hidden',
            name: 'add_another',
            value: 'true'
        }));
    });


    $('#order_next_step').on('click', function (event) {
        event.preventDefault();
        const active_row = $('.active-row')
        const currentUrl = window.location.href;
        const playerId = active_row.data('player')
        const teamId = active_row.data('team')
        const scan_id = active_row.data('scan')

        Turbo.visit(`/orders/0/gallery?player_id=${playerId}&team_id=${teamId}`, {frame: '_top'});
    })


    $('#export_bulks').on('click', function (event) {
        event.preventDefault();
        const active_row = $('.active-row')
        const currentUrl = window.location.href;
        const playerId = active_row.data('player')
        const teamId = active_row.data('team')
        const scan_id = active_row.data('scan')
        Turbo.visit("/bulks/export_to_excel");
    })

    $('#import_bulks').on('click', function (event) {
        event.preventDefault();
        const active_row = $('.active-row')
        const currentUrl = window.location.href;
        const playerId = active_row.data('player')
        const teamId = active_row.data('team')
        const scan_id = active_row.data('scan')
    })
}

function visitPlayer() {
    event.preventDefault();
    let active_row = $('.active-row')
    let first_name = active_row.find('#aetrex_player_first_name').html()
    let last_name = active_row.find('#aetrex_player_last_name').html()
    let email = active_row.find('#aetrex_player_email').html()
    let scan_id = active_row.find('#aetrex_scan_id').html()
    let scan_hash = active_row.find('#aetrex_scan_hash').html()

    Turbo.visit("/aetrex/player?first_name=" + first_name + "&last_name=" + last_name + "&email=" + email +
        "&scan_id=" + scan_id + "&scan_hash=" + scan_hash, {frame: '_top'});
}

function assignPlayer(customizer) {
    let active_row = $('.active-row')
    let player_id = active_row.data('player');
    let team_id = active_row.data('team');
    let scanner_id = active_row.data('scanner')
    let queryString = window.location.search;
    let params = new URLSearchParams(queryString);
    let scan_id = params.get('scan_id');
    var scan_hash = params.get('scan_hash');

    $.ajax({
        type: 'POST',
        url: '/aetrex/assign_player',
        data: $.param({player_id: player_id, scan_id: scan_id, scan_hash: scan_hash}),
        success: function () {
            if (customizer)
                Turbo.visit('/products?player_id=' + player_id + "&team_id=" + team_id + "&scan_id=" + scan_id)
            else
                Turbo.visit(`/aetrex?scanner_id=${scanner_id}`)
        },
        error: function (xhr, status, error) {
            console.error('Error:', error);
        }
    })
}

function aetrexToNewPlayer() {
    event.preventDefault();
    let active_row = $('.active-row')
    let player_id = active_row.data('id');
    let scan_id = active_row.find('#aetrex_scan_id').html()

    Turbo.visit('/orders/new?type=player&player_id=' + player_id + "&scan_id=" + scan_id)
}

function toggleSubmitButton() {
    const checkbox = $('#submit_terms_checkbox');
    const submitButton = $('#order_submit_button');

    if (checkbox.length === 0 || submitButton.length === 0) { return }

    const hasErrors = submitButton.data('has-errors');

    if (hasErrors) {
        submitButton.addClass('disabled');
        return
    }

    if (checkbox.is(':checked')) {
        submitButton.removeClass('disabled')
    } else {
        submitButton.addClass('disabled')
    }
}

function toggleCustomizationTypeSection() {
    let withoutScanRadio = $('.without-scan');
    let proCustomRadioButton = $('.pro-custom-option');
    let customizationTypeSection = $('#customization_type_section');
    let scansPresent = customizationTypeSection.data('scansPresent');

    let isSkate = customizationTypeSection.data('isSkate');

    if (!proCustomRadioButton) return;

    if (isSkate && (withoutScanRadio.is(':checked') || !scansPresent)) {
        proCustomRadioButton.addClass('d-none');

        if ($('input[type=radio]', proCustomRadioButton).is(':checked')) {
            $('input[type=radio]:visible', customizationTypeSection).first().prop('checked', true);
        }
    } else {
        proCustomRadioButton.removeClass('d-none');
    }

    // Goalie skates only allow Pro Custom (scan required). With no other option left, block Next.
    let nextButton = $('#order_type_next');
    if (isSkate && nextButton.length) {
        let hasOption = $('input[name=customization_type]', customizationTypeSection)
            .filter(function () { return !$(this).closest('.pro-custom-option').hasClass('d-none'); }).length > 0;

        if (!hasOption) {
            nextButton.prop('disabled', true).data('disabledByScan', true);
        } else if (nextButton.data('disabledByScan')) {
            nextButton.prop('disabled', false).removeData('disabledByScan');
        }
    }
}

function overrideAddress() {
    let checkbox = $('#ship_to_override')
    if (!checkbox.length)
        return

    if (checkbox.is(':checked')) {
        $('#manual_address').removeClass('d-none')
        $('.manual_address_required_fields').each(function () {
            $(this).prop('required', true)
        })
        let ship_to_select = $('#ship_to_select')
        ship_to_select.prop('required', false)
        $('#phone').prop('required', true)
        fillExistingShipToFields(ship_to_select)
    } else {
        $('.manual_address_fields').each(function () {
            $(this).prop('required', false)
            $(this).val('')
        })
        $('#phone').removeAttr('required')
        $('#manual_address').addClass('d-none')
    }

    updateShipToSelectStatus();
}

function updateShipToSelectStatus() {
    const shipToSelect = $('#ship_to_select');
    const cantEditShipTo = shipToSelect.data('cantEditShipTo');
    const orderStatusUnderReview = shipToSelect.data('orderStatusUnderReview');
    const companyCode =  window.app.companyCode;

    
    if (cantEditShipTo || orderStatusUnderReview ) {
      shipToSelect.prop('disabled', true);
      $('#ship_to_override').prop('disabled', true);
    } else {
      shipToSelect.prop('disabled', false);
      if ($('#disable_ship_to_override').val() !== '1' && $('#only_expedite').val() !== '1') {
        $('#ship_to_override').prop('disabled', false);
      }
    }

    if (companyCode === 'lax') {
        const soldToSelectValue = $('#sold_to_select').find("option[value='" + $('#sold_to_select').val() + "']").data('country-code');
        const containsWarrCan = $('#sold_to_select').find("option:selected").text().includes('WARR CAN');
    
        if (!containsWarrCan && soldToSelectValue === 'CA') {        
            $('#ship_to_override').prop('disabled', true);
        }
    }
    
    if ($('#ship_to_override').is(':disabled')) {
        $('.manual_address_fields').each(function () {
            $(this).prop('disabled', true)
        })
    }else {
        $('.manual_address_fields').each(function () {
            $(this).prop('disabled', false)
        })
    }
}

function generateShipToSelect() {
    let order_id = $('#checkout_order_id').val()
    let ship_to_id = $('#existing_ship_to').val()
    let sold_to_select = $('#sold_to_select').val()
    let ship_to_select = $('#ship_to_select')

    if (ship_to_select.length && !sold_to_select) {
      ship_to_select.empty()
      let checkbox = $('#ship_to_override')
      if (checkbox.length)
        checkbox.prop('checked', false)
      overrideAddress()

      return
    }

    if (!sold_to_select)
      return

    ship_to_select.empty()

    $.ajax({
      type: 'GET',
      url: '/orders/ship_to_accounts',
      data: $.param({sold_to_account_id: sold_to_select, order_id: order_id, ship_to_account_id: ship_to_id}),
      success: function (data) {
        console.log(data)

        updateShipToSelectStatus();

        ship_to_select.append($("<option selected></option>"))
        $.each(data['data'], function (i, value) {
          let new_option = $("<option></option>").attr("value", value[1]).text(value[0])
          if (value[2])
            new_option.prop('selected', true);
          ship_to_select.append(new_option);
        });
        let override_checkbox = $('#ship_to_override')
        if ($('#ship_to_select option:selected').text().includes('MUST OVERRIDE')) {
          override_checkbox.prop('checked', true)
          override_checkbox.prop('disabled', true)
          $('#must_override').val('1')
        } else {
          $('#must_override').val(null)
          updateShipToSelectStatus();
        }
        overrideAddress()
        fillExistingShipToFields(ship_to_select)
      }
    })
}

function generateSoldToSelect() {
    let order_id = $('#checkout_order_id').val()
    let sold_to_id = $('#existing_sold_to').val()
    let customer_select = $('#customer_select').val()

    let sold_to_select = $('#sold_to_select')
    let ship_to_select = $('#ship_to_select')

    if (sold_to_select.length && !customer_select) {
        sold_to_select.empty()
        ship_to_select.empty()
        let checkbox = $('#ship_to_override')
        if (checkbox.length)
            checkbox.prop('checked', false)
        overrideAddress()

        return
    }

    if (!customer_select)
        return

    sold_to_select.empty()

    $.ajax({
        type: 'GET',
        url: '/orders/sold_to_accounts',
        data: $.param({customer_id: customer_select, order_id: order_id, sold_to_account_id: sold_to_id}),
        success: function (data) {
            console.log(data)

            if ($('#only_expedite').val() !== '1' && $('#cant_edit').val() !== '1') {
                sold_to_select.prop('disabled', false)
            }

            sold_to_select.append($("<option selected></option>"))
            $.each(data['data'], function (i, value) {
                let new_option = $("<option></option>").attr("value", value[1]).attr("data-country-code", value[3]).text(value[0])

                if (value[2])
                    new_option.prop('selected', true);
                sold_to_select.append(new_option);
            });

            generateShipToSelect();
        }
    })

}

function generateItemCategorySelect() {
    let order_id = $('#checkout_order_id').val()
    let scenario_select = $('.scenario_select').val()
    let category_select = $('.item_category_select')

    category_select.prop('disabled', !scenario_select);
    category_select.empty();

    $("<option>")
        .attr("value", '')
        .text('Select One')
        .appendTo(category_select);

    if (!scenario_select)
        return;

    $.ajax({
        type: 'GET',
        url: '/orders/item_categories_by_scenario',
        data: $.param({scenario: scenario_select, order_id: order_id}),
        success: function (data) {
            console.log(data)

            $.each(data['data'], function (i, value) {
                let new_option = $("<option></option>").attr("value", value[1]).text(value[0])
                if (value[2])
                    new_option.prop('selected', true);
                category_select.append(new_option);
            });
        }
    })

}

function adjustLeagueSelect() {
    let league_selected = $('.league_select option:selected')
    if (!league_selected.length)
        return

    if (league_selected.html().length) {
        let selected = league_selected.html().replace(/&nbsp;/g, '')
        league_selected.html(selected)
    }
}

function teamsByPlayer() {
    let playerId = $('.active-row').data('player');

    let active_teams = $('.active_teams')
    let legacy_teams = $('.legacy_teams')
    if (!active_teams.length)
        return

    $.ajax({
        type: 'GET',
        url: '/orders/teams_by_player',
        data: $.param({player_id: playerId}),
        success: function (data) {
            console.log(data)
            active_teams.empty()
            legacy_teams.empty()
            $.each(data['active_teams'], function (i, value) {
                active_teams.append(`<div><span class="fw-bold">${value[0]}</span> <span class="float-end">${value[1]}</span></div>`)
            });
            $.each(data['legacy_teams'], function (i, value) {
                legacy_teams.append(`<div><span class="fw-bold">${value[0]}</span> <span class="float-end">${value[1]}</span></div>`)
            });

        }
    })

}

function bindSubmitPlayer() {
    $('#playerModalContent form').on('submit', function (event) {
        event.preventDefault();
        const form = $(this);
        let action = form.find('input[name="add_another"');
        if (!isValidPlayer()) {
            bindPlyerValidation(form)
            return
        }

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(),
            success: function (response) {
                if (action.length > 0) {
                    $('#playerModalContent').html(response)
                    bindOffcanvasClose()
                    bindSubmitPlayer()
                } else {
                    closeOffcanvasModal()
                    let allowedParams = ['email', 'first_name', 'last_name', 'scan_id', 'scan_hash', 'player_id', 'type', 'team_id', 'league_id', 'player_status'];
                    const player = response['player'];
                    const currentUrl = window.location.href;
                    let url = new URL(currentUrl);
                    let urlParams = getFilteredQueryParams(currentUrl, allowedParams);
                    urlParams['first_name'] = player.first_name;
                    urlParams['last_name'] = player.last_name;
                    urlParams['email'] = player.email;
                    let updatedUrl = updateURL(url.origin + url.pathname, urlParams)

                    Turbo.visit(updatedUrl);
                }
            }
        });

    });
}

function constructQueryString(params) {
    return $.param(params);
}

function updateURL(pathname, params) {
    let newQueryString = constructQueryString(params);

    const queryString = ''
    return `${pathname}?${newQueryString}`;
}

function getFilteredQueryParams(url, allowedParams) {
    let queryParams = {};
    let queryString = url.split('?')[1];
    if (queryString) {
        queryString.split('&').forEach(function(param) {
            const parts = param.split('=');
            const key = parts[0];
            const value = decodeURIComponent(parts[1] || '');
            if (allowedParams.includes(key)) {
                queryParams[key] = value;
            }
        });
    }
    return queryParams;
}

function newPlayerForm() {
    $.ajax({
        url: '/individuals/new',
        data: { 
            first_name: $('#first_name').val(),
            last_name: $('#last_name').val(),
            email: $('#email').val()
        },
        method: 'GET',
        success: function (data) {
            $('#playerModalContent').html(data);

            bindOffcanvasClose();
            bindVerifyButton();
            bindCreateButton();
            bindSelectPlayer(); 
        }
    });
}

function bindCreateButton() {
    $('#playerModalContent form').on('submit', function (event) {
        event.preventDefault();
        const form = $(this);
        let action = form.find('input[name="add_another"');
        if (!isValidPlayer()) {
            bindPlyerValidation(form)
            return
        }

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(),
            success: function (response) {
                if (action.length > 0) {
                    $('#playerModalContent').html(response)
                    bindOffcanvasClose()
                    bindSubmitPlayer()
                } else {
                    closeOffcanvasModal()
                    let allowedParams = ['email', 'first_name', 'last_name', 'scan_id', 'scan_hash', 'player_id', 'type', 'team_id', 'league_id', 'player_status'];
                    const player = response['player'];
                    const currentUrl = window.location.href;
                    let url = new URL(currentUrl);
                    let urlParams = getFilteredQueryParams(currentUrl, allowedParams);
                    urlParams['first_name'] = player.first_name;
                    urlParams['last_name'] = player.last_name;
                    urlParams['email'] = player.email;
                    urlParams['player_id'] = player.id;
                    urlParams['team_id'] = '';
                    urlParams['league_id'] = '';

                    let updatedUrl = updateURL(url.origin + url.pathname, urlParams)

                    Turbo.visit(updatedUrl);
                }
            }
        });

    });
}

function bindSelectPlayer() {
    $('#playerModalContent').on('click', '.select-player', function () {
        event.preventDefault();
        const player = {
            id: $(this).data('player-id'),
            first_name: $(this).data('first-name'),
            last_name: $(this).data('last-name'),
            team_id: $(this).data('team-id')
        };

        selectPlayer(player);
    });
}

function selectPlayer(player) {
    closeOffcanvasModal();

    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    const allowedParams = ['email', 'first_name', 'last_name', 'scan_id', 'scan_hash', 'type', 'team_id', 'league_id', 'player_status'];

    let urlParams = getFilteredQueryParams(currentUrl, allowedParams);

    urlParams['player_id'] = player.id;
    urlParams['first_name'] = player.first_name;
    urlParams['last_name'] = player.last_name;
    urlParams['team_id'] = player.team_id;
    urlParams['league_id'] = '';
    const updatedUrl = updateURL(url.origin + url.pathname, urlParams);

    Turbo.visit(updatedUrl);
}

function bindVerifyButton() {
    $('#playerModalContent').on('click', '#submitTag', function (event) {
        event.preventDefault();
        const form = $(this);
        const firstName = $('#individual_first_name').val().trim();
        const lastName = $('#individual_last_name').val().trim();
        const teamId = $('.team-select').val();

        if (!isValidPlayer()) {
            bindPlyerValidation($('#playerModalContent form'))
            return;
        }

        $.ajax({
            url: '/individuals/verify',
            type: 'POST',
            dataType: 'script',
            data: {
                first_name: firstName,
                last_name: lastName,
                team_id: teamId,
                page: 1
            },
            success: function () {
                console.log('Table updated successfully.');
            },
            error: function () {
                alert('An error occurred while verifying players.');
            }
        });
    });
}

function openPlayerModal() {
    $('#playerFormCanvas').addClass('show')
}

function bindOffcanvasClose() {
    $('.offcanvas .btn-close').on('click', function (event) {
        event.preventDefault();
        closeOffcanvasModal()
    })
}

function closeOffcanvasModal() {
    $('.offcanvas').removeClass('show')
    // location.reload()
}

function bindPlyerValidation(element) {
    let validationElementsString = '#individual_first_name, #individual_last_name';

    if ($('.team-selected').length == 0) {
        validationElementsString += ', .team-select'
    }

    element.on('change', validationElementsString, validPlayer);
    validPlayer()
}

function validPlayer() {
    $('#individual_first_name, #individual_last_name').each(function () {
        if ($(this).val().trim() === '') {
            if (!$(this).next('br').length && !$(this).next('span.text-danger').length) {
                $(this).addClass('is-invalid');
                const errorMessage = $('<br><span class="text-danger">').text('Required field')
                $(this).after(errorMessage)
            }
        } else {
            $(this).removeClass('is-invalid');
            $(this).nextAll('br, span.text-danger').remove();
        }
    });

    teamValidationMessages()
    $('#submitTag, .offcanvas-add-another').prop('disabled', !(isValidPlayer()));
}

function updateAvailableOrganizations() {
    let selectedIds = $('.team-select').map(function () {
        return $(this).val();
    }).get();

    $('.team-select').each(function () {
        let currentSelect = $(this);
        let currentVal = currentSelect.val();

        currentSelect.find('option').each(function () {
            let option = $(this);
            let optionVal = option.val();

            if (optionVal && optionVal !== currentVal && selectedIds.includes(optionVal)) {
                option.prop('disabled', true).hide();
            } else {
                option.prop('disabled', false).show();
            }
        });
    });

    $('select.select2').select2();
}

function isValidPlayer() {
    const firstName = $('#individual_first_name').val();
    const lastName = $('#individual_last_name').val();
    const teamSelected = $('.team-selected');

    return firstName && lastName && (isTeamSelected() || teamSelected.length > 0);
}

function teamValidationMessages() {
    const link = $('.link-to-add-team')

    if (isTeamSelected()) {
        link.nextAll('br, span.text-danger').remove();
        link.removeClass('is-invalid');
    } else {
        const errorMessage = '<br><span class="text-danger">You must select at least one team!</span>';
        if (!link.next('br').length && !link.next('span.text-danger').length) {
            link.after(errorMessage)
            link.addClass('is-invalid')
        }
    }
}

function isTeamSelected() {
    const teamSelected = $('.team-selected');
    const teamSelect = $('.team-select');
    let isValid = true;

    if (teamSelect.length > 0 && !teamSelected.length) {
        let teamSelectValid = false;

        $('.team-select').each(function () {
            if ($(this).val()) {
                teamSelectValid = true;
            }
        });

        if (!teamSelectValid) {
            isValid = false;
        }
    } else if (teamSelect.length == 0 && teamSelected.length == 0) {
        isValid = false;
    } else {
        isValid = true;
    }

    return isValid;
}

// END OF PLAYER MODAL FUNCTIONS

function manageSortableFields() {
    var el = document.getElementById('sortable_fields')
    if (el)
        new Sortable(el, {
            animation: 150,
            handle: '.handle',
            onSort: function (event) {
                setPositionValues(event)
            }
        })

}

function setPositionValues(event) {
    var item = event.item;
    var f = item.closest('#sortable_fields')
    var positions = $(f).find('.object_order')

    positions.each(function (index) {
        $(this).val(index + 1)
    });
}

function handleOrderDateChange() {
    $("#order_date").change(function () {
        const dates = setDates($(this).val())
        $('#start_date').val(dates[0]);
        $('#end_date').val(dates[1]);
    })
}

function setDates(date) {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate);
    firstDayOfMonth.setDate(1);
    const firstDayOfThisYear = new Date(currentDate);
    firstDayOfThisYear.setMonth(0)
    firstDayOfThisYear.setDate(1)

    switch (date) {
        case 'today':
            let startDate = formatedDate(currentDate);
            const endDate = formatedDate(currentDate);
            return [startDate, endDate]
        case 'yesterday':
            const yesterday = new Date(currentDate)
            yesterday.setDate(currentDate.getDate() - 1)

            return [formatedDate(yesterday), formatedDate(yesterday)]
        case 'this_week':
            const diff = currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1);
            const firstDayOfThisWeek = new Date(currentDate);
            firstDayOfThisWeek.setDate(diff);
            const lastDayOfThisWeek = new Date(firstDayOfThisWeek);
            lastDayOfThisWeek.setDate(firstDayOfThisWeek.getDate() + 6)
            return [formatedDate(firstDayOfThisWeek), formatedDate(lastDayOfThisWeek)]
        case 'last_week':
            const lastDayOfLastWeek = new Date(currentDate);
            const daysToSubtract = currentDate.getDay() + (currentDate.getDay() === 0 ? 7 : 0);
            lastDayOfLastWeek.setDate(currentDate.getDate() - daysToSubtract);
            const firstDayOfLastWeek = new Date(lastDayOfLastWeek);
            firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6);
            return [formatedDate(firstDayOfLastWeek), formatedDate(lastDayOfLastWeek)]
        case 'this_month':
            const firstDayOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
            const lastDayOfMonth = new Date(firstDayOfNextMonth);
            lastDayOfMonth.setDate(firstDayOfNextMonth.getDate() - 1);
            return [formatedDate(firstDayOfMonth), formatedDate(lastDayOfMonth)]
        case 'last_month':
            const lastDateOfLastMonth = new Date(firstDayOfMonth);
            lastDateOfLastMonth.setDate(firstDayOfMonth.getDate() - 1);
            const firstDateOfLastMonth = new Date(lastDateOfLastMonth);
            firstDateOfLastMonth.setDate(1);

            return [formatedDate(firstDateOfLastMonth), formatedDate(lastDateOfLastMonth)]
        case 'this_year':
            const lastDayOfYear = new Date(currentDate);
            lastDayOfYear.setMonth(11);
            lastDayOfYear.setDate(31);
            return [formatedDate(firstDayOfThisYear), formatedDate(lastDayOfYear)]
        case 'last_year':
            const lastDayOfLastYear = new Date(firstDayOfThisYear);
            lastDayOfLastYear.setDate(firstDayOfThisYear.getDate() - 1);
            const firstDayOfLastYear = new Date(lastDayOfLastYear);
            firstDayOfLastYear.setMonth(0)
            firstDayOfLastYear.setDate(1)
            return [formatedDate(firstDayOfLastYear), formatedDate(lastDayOfLastYear)]
    }
}

function formatedDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

function fillExistingShipToFields(ship_to_select) {
    if (ship_to_select.val()) {
        $.ajax({
            type: 'GET',
            url: '/orders/ship_to_account',
            data: $.param({ship_to_account_id: ship_to_select.val()}),
            success: function (data) {
                console.log(data)
                let data_arr = data['data']
                $('.manual_address_fields').each(function () {
                    $(this)
                        .val(data_arr.shift())
                        .trigger('change');
                })
            }
        })
    } else {
        $('.manual_address_fields').each(function () {
            $(this).val('')
        })
    }
}

function redirectToEditLead() {
    event.preventDefault();

    let active_row = $('.active-row')
    let lead_id = active_row.data('id')
    Turbo.visit(`/leads/${lead_id}/gallery`, { frame: "_top" });
}

function redirectToEdit() {
    event.preventDefault();

    let active_row = $('.active-row')
    let order_id = active_row.data('id')
    const soldTo = active_row.data('soldTo');
    const order_line_id = active_row.data('line');
    const recipe_id = active_row.data('recipe');
    const segment = active_row.data('segment');

    const status = active_row.data('status');
    const reorder = active_row.data('reorder')
    const hasDraftRevision = active_row.is('[data-has-draft-revision]')
    const roles = window.app.user.roles;
    const companyCode = window.app.companyCode;
    const isProShop = roles.includes('PRO SHOP');
    const isAdmin = roles.some(role => ['ADMINISTRATORS', 'CUSTOMER SERVICE'].includes(role));
    const isAdministrator = roles.includes('ADMINISTRATORS');
    const editableStatuses = ['submitted', 'under_review', 'approved'];

    // Recipe-repair flow: an ADMINISTRATORS user editing an order that's already past
    // draft goes straight into the CART (gallery) view, never checkout -- this flow is
    // for fixing recipe attributes in place, not resubmitting the order.
    const adminRecipeRepairStatuses = ['submitted', 'credit_hold', 'new_order', 'on_hold', 'processing', 'produced', 'fulfilled'];
    if (isAdministrator && adminRecipeRepairStatuses.includes(status)) {
        Turbo.visit(`/orders/${order_id}/gallery`, { frame: "_top" });
        return;
    }

    if (editableStatuses.includes(status)) {
        if (isProShop) {
            Turbo.visit(`/orders/${order_id}/gallery`, { frame: "_top" });
            return;
        } else if (isAdmin) {
            Turbo.visit(`/orders/${order_id}/checkout`, { frame: "_top" });
            return;
        }
    }

    const hasCustomerServiceRole = roles.some(string => /customer\s+service/i.test(string));
    if (segment == 'TEAM') {
        if (
            status == "design" ||
            status == "draft" ||
            (isProShop && status == "under_review")
        ) {
            Turbo.visit(`/orders/${order_id}/gallery`, { frame: "_top" });
        } else {
            Turbo.visit(`/orders/${order_id}/checkout`, { frame: "_top" });
        }
    } else if (segment == 'PLAYER') {
        if (isProShop && (status === 'under_review' || status === 'approved')) {
            Turbo.visit(`/orders/${order_id}/gallery`, { frame: "_top" });
        } else if (status == 'design' || status == 'draft') {
            if (hasCustomerServiceRole && soldTo) {
                Turbo.visit(`/orders/${order_id}/checkout`, {frame: '_top'});
            } else {
                Turbo.visit(`/orders/${order_id}/gallery`, { frame: "_top" });
            }
        } else {
            Turbo.visit(`/orders/${order_id}/checkout`, {frame: '_top'});
        }
    }
}

function redirectToShow() {
    event.preventDefault();

    let active_row = $('.active-row')
    let order_id = active_row.data('id')

    Turbo.visit(`/orders/${order_id}`, {frame: '_top'});
}

function redirectToShowLeads() {
    event.preventDefault();

    let active_row = $('.active-row')
    let lead_id = active_row.data('id')

    Turbo.visit(`/leads/${lead_id}`, {frame: '_top'});
}

function redirectToCustomizer(params = {}) {
    const active_row = $('.active-row');
    const order_id = active_row.data('id');
    const order_line_id = active_row.data('line');
    const recipe_id = active_row.data('recipe');
    const queryParams = $.param({ order_line_id, recipe_id, ...params });
    let customizer_url = `/orders/${order_id}/customizer?${queryParams}`

    window.location = customizer_url;
}

function crdValidation() {
    let dateInput = $("#crd_field");
    let submitBtn = $(".checkout_submit_button")

    $('#checkout_submit_form').submit(function (event) {
            let minCrd = $('#calculated_crd')
            if (dateInput.is(":disabled")) {
                return;
            }

            const selectedDate = new Date(dateInput.val());
            const minDate = new Date(minCrd.val());

            if (selectedDate < minDate) {
                dateInput.val(minCrd.val());
            }
        }
    )

    dateInput.on("input", function () {
        submitBtn.prop('disabled', false);
    });
}
